import React, { useEffect } from 'react';
import Paragraph from '../../Typography/Paragraph';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
export const snackbarDuration = {
    short: 4000,
    long: 10000,
};
export const SnackbarWithoutRef = ({ snackbarState, label, direction = 'horizontal', duration = 'short', action, hideSnackbarHandler, ...commonProps }) => {
    const wrapperClasses = clsx(commonProps.className, styles.root);
    const componentClasses = clsx(styles.snackbar, styles[direction], {
        [styles.showing]: snackbarState === 'showing',
        [styles.hidding]: snackbarState === 'hidding',
    });
    useEffect(() => {
        if (snackbarState === 'shown') {
            setTimeout(hideSnackbarHandler, snackbarDuration[duration]);
        }
    }, [snackbarState, hideSnackbarHandler, duration]);
    if (snackbarState === 'hidden') {
        return null;
    }
    return Depot.createElement('div', {
        ...commonProps,
        className: wrapperClasses,
        testId: 'Snackbar',
    }, React.createElement("div", { className: componentClasses },
        React.createElement(Paragraph, { color: "inverted", typeStyle: "body" }, label),
        action && action));
};
const Snackbar = Depot.withRef(SnackbarWithoutRef);
Snackbar.displayName = 'Snackbar';
export default Snackbar;
//# sourceMappingURL=index.js.map